
import { SelectionModel } from '@angular/cdk/collections';
import { TestsService } from 'src/app/core/services/tests.service';


import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChange, ViewChild } from '@angular/core';
import { Entity } from 'src/app/core/models/entity.model';
import { MultilevelItem } from 'src/app/core/models/multilevel-selector.model';
import { User } from 'src/app/core/models/user.model';
import { LicenseService } from 'src/app/core/services/license.service';
import * as utils from 'src/app/shared/helpers/utils';
import { ConfigService } from 'src/app/core/services/config.service';
import { distinctUntilChanged, map, Subscription } from 'rxjs';

const singleSelectTypes: string[] = ['analyticPackages', 'newPackage', 'locatedList', 'located', 'user', 'newUser', 'newTeam', 'newDevice', 'device', 'policy', 'reassignPackage', 'reassignNoDevice'];
const onlyDistHo: string[] = ['analyticPackages'];
const parentStatusTypes: string[] = ['fitsAnalytics', 'gazeMapsAnalytics', 'fits', 'gazeMaps'];



export interface TreeNode {
  [key: string | number]: any;
  name: string;
  level: number;
  expandable: boolean;
  expanded?: boolean;
  children?: TreeNode[];
  id?: number;
}

const TREE_DATA: TreeNode[] = [
  {
    name: 'Parent 1',
    level: 0,
    expandable: true,
    children: [
      {
        name: 'Child 1.1',
        level: 1,
        expandable: true,
        children: [
          { name: 'Grandchild 1.1.1', level: 2, expandable: false },
          { name: 'Grandchild 1.1.2', level: 2, expandable: false }
        ]
      },
      {
        name: 'Child 1.2',
        level: 1,
        expandable: true,
        children: [{ name: 'Grandchild 1.2.1', level: 2, expandable: false }]
      }
    ]
  },
  {
    name: 'Parent 2',
    level: 0,
    expandable: true,
    children: [
      { name: 'Child 2.1', level: 1, expandable: true, children: [{ name: 'Grandchild 2.1.1', level: 2, expandable: false }] }
    ]
  }
];




interface FlatNode {
  name: string;
  level: number;
  expandable: boolean;
}

/** @title Basic virtual scroll */
@Component({
  selector: 'app-basic-virtual-scroll',
  templateUrl: './basic-virtual-scroll.component.html',
  styleUrls: ['./basic-virtual-scroll.component.scss'],
  styles: [`
    .tree-viewport { height: 340px; width:100%; overflow: auto; }
  `]
})




export class BasicVirtualScrollComponent implements AfterViewInit {

  @ViewChild('inputSearch') inputSearch!: ElementRef;

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target) && !this.sameValuesUnordered(this.configSvc.currentConfigValue[`${this.typeData}Selected`]?.map((n: TreeNode) => n.id) ?? [], this.configSvc.currentConfigValue[`${this.typeData}SelectedApplied`]?.map((n: TreeNode) => n.id) ?? [])) {
      console.log('here');
      switch (this.typeData) {
        case 'entitiesList':
          this.callbackClickOutside.emit({ exec: true, opened: this.virtualScrollOpened });
          this.virtualScrollOpened = false;
          break;
        default:
          this.callbackClickOutside.emit({ exec: true, opened: this.virtualScrollOpened });
          this.virtualScrollOpened = false;
          break;
      }
    } else {
      switch (this.typeData) {
        case 'policy':
          this.callbackClickOutside.emit({ exec: true, opened: this.virtualScrollOpened, id: this.selection.selected[0]?.id });
          this.virtualScrollOpened = false;
          break;
        default:
          break;
      }
    }
  }


  multilevelSelectorHead: string = 'DATATABLE.FILTERS.EVERYENTITY';
  multilevelSelectorHeadNumber!: number;
  clearSelectorPB!: boolean;
  oneTreeNode!: boolean;
  maxLevel!: number;
  minLevel!: number;
  selectorSearch!: string;
  allSelected!: boolean;
  data: MultilevelItem[] = [];
  user: User = utils?.localStorageGetItem('user');
  showDropdown!: boolean;
  @Input("parentEntityId") parentEntityId!: string | null;
  @Input("entityId") entityId!: number | null;
  @Input("currentEntityId") currentEntityId!: string | null;
  @Input("clearSelector") clearSelector!: boolean;
  @Input("search") search!: string | undefined;
  @Input("typeData") typeData!: string;
  @Input("entityType") entityType!: number;
  @Output('callback') callback = new EventEmitter;
  @Output('callbackClickOutside') callbackClickOutside = new EventEmitter;
  @Output('callbackObject') callbackObject = new EventEmitter;
  @ViewChild('selector') selector!: ElementRef;
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: { target: any; }): void {
    if (!this.selector.nativeElement.contains(event.target)) {
      // clicked outside => close dropdown list
      //this.selectorSearch = '';
      //this.data.map((item: MultilevelItem) => this.iterateItemVisible(item));
      this.showDropdown = false;
    }
  }

  visibleNodes: TreeNode[] = [];
  // A search rebuilds the tree from cloned entities, so the same entity is a different object on every
  // keystroke and reference identity stops matching what is rendered. Compare by id, falling back to
  // reference identity for nodes without one (findNodeById returns null, and nulls must not collide).
  selection = new SelectionModel<TreeNode>(true, [], true, (a, b) => a?.id != null && a.id === b?.id);
  tree$: TreeNode[] = [];

  @Input("customTreeNode") customTreeNode!: Entity[] | undefined;
  // Bump it to force a rebuild: the tree is only reloaded from ngOnChanges
  @Input() reloadToken?: number;
  // Extra, caller-owned restriction on top of the per-typeData rules. Pass a stable reference:
  // a binding that changes would re-run ngOnChanges, rebuilding the tree and clearing the selection.
  @Input("disableNode") disableNode?: (node: TreeNode) => boolean;

  adminWraper: number = 0;
  virtualScrollOpened: boolean = false;


  constructor(
    private eRef: ElementRef,
    private jerarquiaService: TestsService,
    public configSvc: ConfigService,
    public licenseService: LicenseService
  ) {

    this.updateVisibleNodes();
    switch (this.typeData) {
      default:
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData).subscribe(
          (data) => {
            this.tree$ = data;
            this.tree$ = this.addOwnEntity(data);
            this.updateVisibleNodes();
            switch (this.typeData) {
              case 'fitsAnalytics':
              case 'gazeMapsAnalytics':
              case 'fits':
              case 'gazeMaps':
                this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.filter((entity: Entity) => entity['entityTypeId'] === 4).length;
                break;
              default:
                this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
                break;
            }
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
    }

  }

  ngOnChanges(changes: SimpleChange) {
    switch (this.typeData) {
      case 'policy':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData, this.customTreeNode).subscribe(
          (data) => {
            if (this.user.roleId !== 1) this.tree$ = this.removeOwnEntity(data);
            this.selection.clear();
            this.tree$ = data;
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        if (this.clearSelector) (this.selection.clear(), this.setSelectedNodes([]), this.clearSelector = false, this.callbackObject.emit({ type: 'policy', value: false }), this.multilevelSelectorHead = 'COMMON.ENTITY');
        break;
      case 'located':
        /*if (this.configSvc.currentConfigValue?.user?.roleId !== 1) {
          this.customTreeNode?.push(this.configSvc.currentConfigValue.userEntity!);
        }*/
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData, this.customTreeNode).subscribe(
          (data) => {
            if (!this.currentEntityId || this.currentEntityId === data[0].id) {
              this.selection.clear();
              this.tree$ = data;
              this.setSelectedNodes([this.tree$[0]]);
              this.callback.emit(this.tree$[0].id);
            } else {
              if (this.user.roleId === 1) (
                this.tree$ = data,
                this.setSelectedNodes([this.findNodeById(this.tree$, Number(this.currentEntityId))])
              )
              else (
                this.tree$ = this.addOwnEntity(data),
                this.selection.clear(),
                this.setSelectedNodes([this.findNodeById(this.tree$, Number(this.currentEntityId))])
              );
            }
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;

          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'analyticPackages':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData, undefined, this.entityType).subscribe(
          (data) => {
            this.selection.clear();
            this.tree$ = data;
            if (this.user.roleId === 2) this.tree$[0].expanded = true;
            this.setSelectedNodes([this.findNodeById(this.tree$, Number(this.currentEntityId))]);
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'locatedList':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData, undefined, this.entityType).subscribe(
          (data) => {
            this.selection.clear();
            if (this.currentEntityId === '1' || this.currentEntityId === data[0].id) {
              this.tree$ = data;
            } else {
              if (this.user.roleId === 1) this.tree$ = data
              else this.tree$ = this.addOwnEntity(data);
            }
            if (this.user.roleId === 2) this.tree$[0].expanded = true;
            this.setSelectedNodes([this.findNodeById(this.tree$, Number(this.currentEntityId))]);
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'newTeam':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData, this.customTreeNode).subscribe(
          (data) => {
            this.selection.clear();
            this.tree$ = data;
            if (this.user.roleId !== 1) this.tree$ = this.removeOwnEntity(data);
            console.log(this.tree$);
            this.setSelectedNodes([this.tree$[0]]);
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
            this.callback.emit(this.tree$[0].id);
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'reassignPackage':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData, this.customTreeNode).subscribe(
          (data) => {
            // A caller-narrowed list must win for every role: admins otherwise keep the full tree
            // the constructor built, when typeData was still undefined.
            if (this.customTreeNode) this.tree$ = data;
            else if (this.user.roleId !== 1) this.tree$ = this.removeOwnEntity(data);
            this.selection.clear();
            // Clearing the selection is not enough: the header keeps the previously chosen entity's
            // name until it is recomputed, so it would still read as selected after a reload.
            this.setHeader();
            //this.setSelectedNodes([this.tree$[0]]);
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
            //this.callback.emit(this.tree$[0].id);
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'reassignNoDevice':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData, this.customTreeNode).subscribe(
          (data) => {
            this.tree$ = data;
            this.selection.clear();
            this.updateVisibleNodes();
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'newDevice':
      case 'newUser':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData, this.customTreeNode).subscribe(
          (data) => {
            this.tree$ = this.addOwnEntity(data);
            this.selection.clear();
            this.setSelectedNodes([this.findNodeById(this.tree$, Number(this.currentEntityId))]);
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
            //this.callback.emit(this.tree$[0].id);
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'device':
      case 'user':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData,).subscribe(
          (data) => {
            this.tree$ = this.addOwnEntity(data);
            console.log(this.tree$);
            this.selection.clear();
            if (this.currentEntityId) this.setSelectedNodes([this.findNodeById(this.tree$, Number(this.currentEntityId))]);
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
          },
          (error: any) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'package':
      case 'newPackage':
        const prevSelectedIds = this.selection.selected.map((n: TreeNode) => n.id);
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData,).subscribe(
          (data) => {
            this.tree$ = this.removeOwnEntity(data);
            this.selection.clear();
            prevSelectedIds.forEach((id: number | undefined) => {
              if (id) {
                const found = this.findNodeById(this.tree$, id);
                if (found) this.selection.select(found);
              }
            });
            if (this.currentEntityId) this.setSelectedNodes([this.findNodeById(this.tree$, Number(this.currentEntityId))]);
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'devicesList':
      case 'entitiesList':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData,).subscribe(
          (data) => {
            if (this.user.roleId == 1 && this.typeData === 'entitiesList') this.tree$ = this.removeOwnEntity(data);
            this.selection.clear();
            if (this.currentEntityId) this.setSelectedNodes([this.findNodeById(this.tree$, Number(this.currentEntityId))]);
            this.updateVisibleNodes();
            if (this.user.roleId !== 1) this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length + 1
            else this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'fitsAnalytics':
      case 'gazeMapsAnalytics':
      case 'fits':
      case 'gazeMaps':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData).subscribe(
          (data) => {
            // For gazeMaps: remove own entity for non-admins
            if (this.user.roleId !== 1) {
              this.tree$ = this.removeOwnEntity(data);
            } else {
              this.tree$ = data;
            }
            this.selection.clear();
            if (this.currentEntityId) this.setSelectedNodes([this.findNodeById(this.tree$, Number(this.currentEntityId))]);
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.filter((entity: Entity) => entity['entityTypeId'] === 4).length;
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'settingsList':
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData).subscribe(
          (data) => {
            // For settingsList: remove own entity if user is admin (roleId === 1)
            if (this.user.roleId === 1) {
              this.tree$ = this.removeOwnEntity(data);
              this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
            } else {
              this.tree$ = this.addOwnEntity(data);
              this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length + 1;
            }
            this.selection.clear();
            if (this.currentEntityId) this.setSelectedNodes([this.findNodeById(this.tree$, Number(this.currentEntityId))]);
            this.updateVisibleNodes();
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      case 'policiesList':
        // The constructor built this tree before typeData was bound, with every entity type in it
        this.jerarquiaService.obtenerYJerarquizarJson(this.typeData).subscribe(
          (data) => {
            this.tree$ = data;
            this.selection.clear();
            this.updateVisibleNodes();
            this.multilevelSelectorHeadNumber = this.countDistributors();
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        break;
      default:
        switch (this.typeData) {
          case 'fits':
            this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.filter((entity: Entity) => entity['entityTypeId'] === 4).length;
            break;
          default:
            if (this.user.roleId !== 1) this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length + 1;
            else this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
            break;
        }
        break;
    }
    console.log(this.configSvc.currentConfigValue.userEntity);
    if (!this.configSvc.currentConfigValue.childEntities!.length) {
      let userEntityNode: TreeNode;
      userEntityNode = (this.configSvc.currentConfigValue.userEntity! as unknown) as TreeNode;
      if (!userEntityNode) return;
      userEntityNode!.expanded = true;
      userEntityNode!.level = -1;
      this.tree$ = [userEntityNode!];
      this.setSelectedNodes([this.tree$[0]]);
      this.oneTreeNode = true;
    } else if (this.configSvc.currentConfigValue.childEntities!.length === 1) {
      this.oneTreeNode = true;
      this.setSelectedNodes([this.tree$[0]]);
    }
  }
  findNodeById = (nodes: any[], id: number): any | null => {
    for (const node of nodes) {
      if (node.id === id) return node;
      if (node.children && node.children.length) {
        const found = this.findNodeById(node.children, id);
        if (found) return found;
      }
    }
    return null;
  }
  ngAfterViewInit() {
    //this.callback.emit(this.selection.selected.map( item => item.id));
    switch (this.typeData) {
      case 'package':
        this.configSvc.currentConfigValue.packageEntitiesSelectedApplied
          ? this.setSelectedNodes(this.configSvc.currentConfigValue.packageEntitiesSelectedApplied)
          : null;
        break;
      case 'fitsAnalytics':
        this.configSvc.currentConfigValue.fitsEntitiesAnalyticsSelectedApplied
          ? this.setSelectedNodes(this.configSvc.currentConfigValue.fitsEntitiesAnalyticsSelectedApplied)
          : null;
        break;
      case 'fits':
        this.configSvc.currentConfigValue.fitsEntitiesSelectedApplied
          ? this.setSelectedNodes(this.configSvc.currentConfigValue.fitsEntitiesSelectedApplied)
          : null;
        break;
      case 'gazeMapsAnalytics':
        this.configSvc.currentConfigValue.gazeMapsEntitiesAnalyticsSelectedApplied
          ? this.setSelectedNodes(this.configSvc.currentConfigValue.gazeMapsEntitiesAnalyticsSelectedApplied)
          : null;
        break;
      case 'gazeMaps':
        this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied
          ? this.setSelectedNodes(this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied)
          : null;
        break;
      case 'usersList':
        this.configSvc.currentConfigValue.usersListSelectedApplied
          ? this.setSelectedNodes(this.configSvc.currentConfigValue.usersListSelectedApplied)
          : null;
        break;
      case 'entitiesList':
        this.configSvc.currentConfigValue.entitiesListSelectedApplied
          ? this.setSelectedNodes(this.configSvc.currentConfigValue.entitiesListSelectedApplied)
          : null;
        break;
      case 'settingsList':
        this.configSvc.currentConfigValue.settingsListSelectedApplied
          ? this.setSelectedNodes(this.configSvc.currentConfigValue.settingsListSelectedApplied)
          : null;
        break;

      case 'devicesList':
        this.configSvc.currentConfigValue.devicesListSelectedApplied
          ? this.setSelectedNodes(this.configSvc.currentConfigValue.devicesListSelectedApplied)
          : null;
        break;
      case 'policiesList':
        this.configSvc.currentConfigValue.policiesListSelectedApplied
          ? this.setSelectedNodes(this.configSvc.currentConfigValue.policiesListSelectedApplied)
          : null;
        break;
      case 'analyticPackages':
      case 'reassignPackage':
      case 'policy':
      case 'newPackage':
        this.multilevelSelectorHead = 'COMMON.ENTITY';
        break;
      default: break;
    }

  }

  setSelectedNodes(nodes: TreeNode[]) {
    // Select specific nodes (e.g., select the first and third node)
    nodes.map((node: TreeNode) => this.selection.select(node));
    this.setHeader();
    // If you want to clear previous selections before setting new ones:
    // this.selection.clear();
    // this.selection.select(this.nodes[0], this.nodes[2]);

  }

  toogleDropdown() {
    this.showDropdown = !this.showDropdown;
    if (this.showDropdown) setTimeout(() => {
      if (this.inputSearch) this.inputSearch?.nativeElement.focus()
    }, 0);
  }


  clear(e: any) {
    this.allSelected = true;
    this.clearSelectorPB = false;
    this.selection.clear();
    switch (this.typeData) {
      case 'package':
        this.configSvc.setConfigParamsValue('packageEntitiesSelected', null);
        break;
      case 'fitsAnalytics':
        this.configSvc.setConfigParamsValue('fitsEntitiesAnalyticsSelected', null);
        break;
      case 'fits':
        this.configSvc.setConfigParamsValue('fitsEntitiesSelected', null);
        break;
      case 'gazeMapsAnalytics':
        this.configSvc.setConfigParamsValue('gazeMapsEntitiesAnalyticsSelected', null);
        break;
      case 'gazeMaps':
        this.configSvc.setConfigParamsValue('gazeMapsEntitiesSelected', null);
        break;
      case 'usersList':
        this.configSvc.setConfigParamsValue('usersListSelected', null);
        break;
      case 'entitiesList':
        this.configSvc.setConfigParamsValue('entitiesListSelected', null);
        break;
      case 'settingsList':
        this.configSvc.setConfigParamsValue('settingsListSelected', null);
        break;
      case 'devicesList':
        this.configSvc.setConfigParamsValue('devicesListSelected', null);
        break;
      case 'policiesList':
        this.configSvc.setConfigParamsValue('policiesListSelected', null);
        break;
      default:
        break;
    }

    this.setHeader();
    this.search = '';
    this.data = [];
    this.callback.emit('change');

  }

  onChange(e: Event, _type?: string) {
    this.search = e.toString();
    switch (_type) {
      case 'search':
        this.jerarquiaService.searchFiltering(e.toString(), this.typeData).subscribe(
          (data) => {
            switch (this.search!.length) {
              case 0:
                switch (this.typeData) {
                  case 'device':
                  case 'newDevice':
                  case 'user':
                  case 'newUser':
                    this.tree$ = this.addOwnEntity(data);
                    break;
                  default:
                    this.tree$ = data;
                    break;
                }
                break;
              default:
                switch (this.typeData) {
                  case 'package':
                  case 'device':
                  case 'newDevice':
                  case 'user':
                  case 'newUser':
                    if (this.configSvc.currentConfigValue.userEntity!.name.toLowerCase()?.includes(this.search?.toLowerCase()!)) {
                      this.tree$ = this.addOwnEntity(data)
                    } else {
                      this.tree$ = data;
                    }
                    break;
                  default:
                    this.tree$ = data;
                    break;
                }
            }
            this.updateVisibleNodes();
            switch (this.typeData) {
              case 'package':
                this.configSvc.currentConfigValue.packageEntitiesSelected
                  ? this.setSelectedNodes(this.configSvc.currentConfigValue.packageEntitiesSelected)
                  : null;
                break;
              case 'fitsAnalytics':
                this.configSvc.currentConfigValue.fitsEntitiesAnalyticsSelected
                  ? this.setSelectedNodes(this.configSvc.currentConfigValue.fitsEntitiesAnalyticsSelected)
                  : null;
                break;
              case 'fits':
                this.configSvc.currentConfigValue.fitsEntitiesSelected
                  ? this.setSelectedNodes(this.configSvc.currentConfigValue.fitsEntitiesSelected)
                  : null;
                break;
              case 'gazeMapsAnalytics':
                this.configSvc.currentConfigValue.gazeMapsEntitiesAnalyticsSelected
                  ? this.setSelectedNodes(this.configSvc.currentConfigValue.gazeMapsEntitiesAnalyticsSelected)
                  : null;
                break;
              case 'gazeMaps':
                this.configSvc.currentConfigValue.gazeMapsEntitiesSelected
                  ? this.setSelectedNodes(this.configSvc.currentConfigValue.gazeMapsEntitiesSelected)
                  : null;
                break;
              case 'usersList':
                this.configSvc.currentConfigValue.usersListSelected
                  ? this.setSelectedNodes(this.configSvc.currentConfigValue.usersListSelected)
                  : null;
                break;
              case 'entitieslist':
                this.configSvc.currentConfigValue.entitiesListSelected
                  ? this.setSelectedNodes(this.configSvc.currentConfigValue.entitiesListSelected)
                  : null;
                break;
              case 'settingsList':
                this.configSvc.currentConfigValue.settingsListSelected
                  ? this.setSelectedNodes(this.configSvc.currentConfigValue.settingsListSelected)
                  : null;
                break;

              case 'devicesList':
                this.configSvc.currentConfigValue.devicesListSelected
                  ? this.setSelectedNodes(this.configSvc.currentConfigValue.devicesListSelected)
                  : null;
                break;
              case 'policiesList':
                this.configSvc.currentConfigValue.policiesListSelected
                  ? this.setSelectedNodes(this.configSvc.currentConfigValue.policiesListSelected)
                  : null;
                break;
              default:
                break;
            };
          },
          (error) => {
            console.error('Error al obtener el JSON', error);
          }
        );
        this.callback.emit('change');
        break;
      default:
        this.callback.emit('change');
        break;
    }

  }

  addOwnEntity = (_data: any) => {
    let userEntityNode: TreeNode;
    userEntityNode = (this.configSvc.currentConfigValue.userEntity! as unknown) as TreeNode;
    if (!userEntityNode) return _data;
    userEntityNode.children = _data;
    userEntityNode.expanded = true;
    userEntityNode.level = -1;
    if (_data.length) userEntityNode.expandable = true;
    this.adminWraper = 10;
    return [userEntityNode];
  }

  removeOwnEntity = (_data: TreeNode[]): TreeNode[] => {
    // Check if data is wrapped with user entity (has adminWraper or user entity structure)
    if (_data.length === 1 && _data[0].level === -1 && _data[0].children) {
      // Return the children (original data) instead of the wrapper
      this.adminWraper = 0;
      return _data[0].children;
    }
    // If data is not wrapped, return as is
    return _data;
  }

  applyFilters() {
    console.log(this.selectorSearch);
  }

  updateVisibleNodes() {
    //this.visibleNodes = this.flattenTree(TREE_DATA);
    // Add safety check
    if (!this.tree$ || !Array.isArray(this.tree$) || this.tree$.length === 0) {
      console.log('tree$ not ready or empty:', this.tree$);
      this.visibleNodes = [];
      return;
    }
    this.visibleNodes = this.flattenTree(this.tree$);
  }

  flattenTree(nodes: TreeNode[], level = 0): TreeNode[] {
    let result: TreeNode[] = [];
    for (let node of nodes) {
      result.push(node);
      if (node.expanded && node.children) {
        result = result.concat(this.flattenTree(node.children, level + 1));
      }
    }
    return result;
  }

  toggleNode(node: TreeNode) {
    node.expanded = !node.expanded;
    this.updateVisibleNodes();
  }
  toggleAll(e: Event, node: TreeNode) {
    e.preventDefault();
    const keepSearchValue = this.inputSearch.nativeElement.value;
    if (this.inputSearch.nativeElement.value.length) {
      this.setSearch('');
      this.toggleAll(e, node);
      this.setSearch(keepSearchValue);
    } else {
      // The flag used to decide this, but a search renders a fresh clone of the node on every keystroke,
      // so it never survived to the next click and every click re-selected. Derive it from the selection.
      const willSelect = !this.selection.isSelected(node);
      this.selection.toggle(node);
      node['allSelected'] = willSelect;
      if (willSelect) (this.childrenSelection(node, true), node.expanded = true, this.updateVisibleNodes())
      else this.childrenSelection(node, false);
      this.setHeader();
      switch (this.includedSingleType()) {
        case true:
          this.selection.clear();
          this.selection.select(node);
          this.setHeader();
          this.showDropdown = false;
          this.callback.emit(node.id);
          break;
        default:
          this.callback.emit('change');
          break;
      }
    }
  }

  setSearch(_string: string) {
    this.search = _string;
    this.inputSearch.nativeElement.value = _string;
    this.applyFilters();
    this.onChange(this.search as unknown as Event, 'search');
  }

  toggleSelection(node: TreeNode) {
    this.selection.toggle(node);
    switch (this.typeData) {
      /*case 'usersList':
      case 'entitiesList':
      case 'devicesList':*/
      case 'fitsAnalytics':
      case 'gazeMapsAnalytics':
      case 'fits':
      case 'gazeMaps':
        if (this.selection.selected.find((n: TreeNode) => n.id === node.id)) this.childrenSelection(node, true)
        else this.childrenSelection(node, false);
        break;
      default: break;
    }

    this.setHeader();
    switch (this.includedSingleType()) {
      case true:
        this.selection.clear();
        this.selection.select(node);
        this.setHeader();
        this.showDropdown = false;
        this.callback.emit(node.id);
        switch (this.typeData) {
          case 'analyticPackages':
            this.allSelected = false;
            break;
          default:
            break;
        }
        break;
      default:
        this.callback.emit('change');
        break;
    }
  }

  deselect(node: TreeNode) {
    this.selection.toggle(node);
    switch (this.typeData) {
      case 'fitsAnalytics':
      case 'gazeMapsAnalytics':
      case 'fits':
      case 'gazeMaps':
        this.setParentStatus(node);
        break;
      default:
        break;
    }
    this.setHeader();
    this.callback.emit('change');
  }

  setHeader = () => {
    switch (this.includedSingleType()) {
      case true:
        if (this.selection.selected.length >= 1) {
          this.multilevelSelectorHeadNumber = this.selection.selected.length;
          this.multilevelSelectorHead = this.selection.selected[0]?.name;
          this.clearSelectorPB = true;
        } else {
          this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
          this.multilevelSelectorHead = 'DATATABLE.FILTERS.EVERYENTITY';
          this.clearSelectorPB = false;
        }
        break;
      default:
        if (this.selection.selected.length >= 1) {
          this.multilevelSelectorHeadNumber = this.selection.selected.length;
          switch (this.typeData) {
            case 'fitsAnalytics':
            case 'gazeMapsAnalytics':
            case 'fits':
            case 'gazeMaps':
              const selectedOpticals = this.selection.selected.filter((n: TreeNode) => n['entityTypeId'] === 4);
              this.multilevelSelectorHeadNumber = selectedOpticals.length;
              if (selectedOpticals.length) {
                this.multilevelSelectorHead = selectedOpticals.length > 1 ? 'DATATABLE.FILTERS.MANYENTITIES' : selectedOpticals[0].name;
              } else {
                this.multilevelSelectorHead = 'DATATABLE.FILTERS.EVERYENTITY';
              }
              break;
            default:
              this.multilevelSelectorHeadNumber = this.selection.selected.length;
              this.multilevelSelectorHead = this.selection.selected.length > 1 ? 'DATATABLE.FILTERS.MANYENTITIES' : this.selection.selected[0].name;
              break;
          }

          this.clearSelectorPB = true;
        } else {
          switch (this.typeData) {
            case 'fitsAnalytics':
            case 'gazeMapsAnalytics':
            case 'fits':
            case 'gazeMaps':
              this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.filter((entity: Entity) => entity['entityTypeId'] === 4).length;
              break;
            case 'policiesList':
              this.multilevelSelectorHeadNumber = this.countDistributors();
              break;
            case 'settingsList':
            case 'devicesList':
            case 'usersList':
            case 'entitiesList':
            default:
              this.multilevelSelectorHeadNumber = this.configSvc.currentConfigValue.entities.length;
              break;
          }
          this.multilevelSelectorHead = 'DATATABLE.FILTERS.EVERYENTITY';
          this.clearSelectorPB = false;
        }
        break;
    }

    switch (this.typeData) {
      case 'package':
        this.configSvc.setConfigParamsValue('packageEntitiesSelected', this.selection.selected.length ? this.selection.selected : null);
        break;
      case 'fitsAnalytics':
        this.configSvc.setConfigParamsValue('fitsEntitiesAnalyticsSelected', this.selection.selected.length ? this.selection.selected : null);
        break;
      case 'fits':
        this.configSvc.setConfigParamsValue('fitsEntitiesSelected', this.selection.selected.length ? this.selection.selected : null);
        break;
      case 'gazeMapsAnalytics':
        this.configSvc.setConfigParamsValue('gazeMapsEntitiesAnalyticsSelected', this.selection.selected.length ? this.selection.selected : null);
        break;
      case 'gazeMaps':
        this.configSvc.setConfigParamsValue('gazeMapsEntitiesSelected', this.selection.selected.length ? this.selection.selected : null);
        break;
      case 'usersList':
        this.configSvc.setConfigParamsValue('usersListSelected', this.selection.selected.length ? this.selection.selected : null);
        break;
      case 'entitiesList':
        this.configSvc.setConfigParamsValue('entitiesListSelected', this.selection.selected.length ? this.selection.selected : null);
        break;
      case 'settingsList':
        this.configSvc.setConfigParamsValue('settingsListSelected', this.selection.selected.length ? this.selection.selected : null);
        break;
      case 'devicesList':
        this.configSvc.setConfigParamsValue('devicesListSelected', this.selection.selected.length ? this.selection.selected : null);
        break;
      case 'policiesList':
        this.configSvc.setConfigParamsValue('policiesListSelected', this.selection.selected.length ? this.selection.selected : null);
        break;
      default:
        break;
    }

    switch (this.typeData) {
      case 'fitsAnalytics':
      case 'gazeMapsAnalytics':
      case 'gazeMaps':
      case 'fit':
        if (!this.configSvc.currentConfigValue.childEntities!) this.multilevelSelectorHead = 'COMMON.NO_RESULTS';
        break;
      default: break;
    };


  }
  ckeckIncludeSelected = (node: any): Boolean => {
    let someSelection = false;
    node.children.map((child: any) => {
      this.selection.selected.some(el => el?.id === child.id) ? someSelection = true : null;
      child.children.map((child: any) => {
        this.selection.selected.some(el => el?.id === child.id) ? someSelection = true : null;
      })
    });

    return someSelection
  }

  excludedSingleType = (): boolean => {
    return !singleSelectTypes.includes(this.typeData)
  }
  includedSingleType = (): boolean => {
    return singleSelectTypes.includes(this.typeData)
  }
  usesParentStatus = (): boolean => {
    return parentStatusTypes.includes(this.typeData)
  }

  childrenSelection = (_node: TreeNode, _select: boolean) => {
    if (_node.children!.length) {
      _node.children?.map((n: TreeNode) => {
        if (_select) { this.selection.select(n) } else { this.selection.deselect(n) }
        if (n.children?.length) {
          this.childrenSelection(n, _select)
        }
      });
      if (this.usesParentStatus()) this.setParentStatus(_node);
    } else {
      if (_node['parentEntityId'] != this.configSvc.currentConfigValue.userEntity!.id) {
        if (this.usesParentStatus()) this.setParentStatus(_node);
      }

    }
  }

  // Only distributors own policies, so that is what "all entities" means in this selector
  countDistributors = (): number => {
    return this.configSvc.currentConfigValue.entities.filter((entity: Entity) => entity['entityTypeId'] === utils.ENTITY_TYPE_DISTRIBUTOR).length;
  }

  onlyOpticals = () => {
    return this.selection.selected.filter((n: TreeNode) => n['entityTypeId'] === 4);

  }

  setParentStatus(_node: TreeNode) {
    //check if parent has any selected
    //if not unselect
    const parent = this.configSvc.currentConfigValue.entities.find((entity: Entity) => entity.id === _node['parentEntityId']);
    if (parent) {
      let someParentChildsSelected: boolean = false;
      parent.children.map((entity: Entity) => {
        if (this.selection.selected.find((n: TreeNode) => n.id === entity.id)) someParentChildsSelected = true;
      });
      if (!someParentChildsSelected) this.selection.deselect(parent)
      else this.selection.select(parent);
      console.log(parent);
      if (parent.entityTypeId !== 1) this.setParentStatus(parent);
    } else {
      /*this.selection.deselect(_node);
      console.log(this.selection.selected);*/
      let someChildsSelected: boolean = false;
      _node['children']?.map((mainN: TreeNode) => {
        if (this.selection.selected.find((n: TreeNode) => n.id === mainN.id)) someChildsSelected = true;
      });
      if (!someChildsSelected) this.selection.deselect(_node);
    }
  }

  disableCheck = (_node: TreeNode): boolean => {
    if (this.disableNode?.(_node)) return true;
    switch (this.typeData) {
      case 'reassignNoDevice':
        return _node['entityTypeId'] !== 4;
      case 'reassignPackage':
        if (this.user.roleId === 1 && _node['entityTypeId'] === 2) return true;
        if (_node['isBase']) return true;
        return false;
      case 'fitsAnalytics':
      case 'gazeMapsAnalytics':
      case 'gazeMaps':
      case 'fits':
        return this.checkNoOpticals(_node);
      default:
        return false
    }
  }

  checkNoOpticals = (_node: TreeNode) => {
    switch (_node['entityTypeId']) {
      case 2:
        if (!_node.children!.length) return true
        else {
          let opticalsHO: boolean = false;
          if (_node.children!.filter((n: TreeNode) => n['entityTypeId'] === 4).length) return false;
          _node.children!.filter((n: TreeNode) => n['entityTypeId'] === 3).map((n: TreeNode) => n.children!.length ? opticalsHO = true : null)
          if (opticalsHO) return false
          else return true
        }
      case 3:
        if (!_node.children!.length) return true
        else return false
      default:
        return false
    }
  };
  onClick = () => {
    this.virtualScrollOpened = true;
  }

  sameValuesUnordered = (a: number[], b: number[]) => {
    if (a.length !== b.length) return false;
    const setA = new Set(a);
    const setB = new Set(b);
    if (setA.size !== setB.size) return false;
    return [...setA].every(val => setB.has(val));
  }

  resetSelection = () => {
    this.allSelected = true;
    this.clearSelectorPB = false;
    this.selection.clear();
    this.setHeader();
    this.search = '';
    this.data = [];
  }

}


